var Acr = Acr || {};
var Ut = window.Utility;

Acr.Footer = function () {


  var languages = {
    en: {
      name: 'English',
      subDomain: 'www',
    },
    es: {
      name: 'Español',
      subDomain: 'spanish',
    },
    zh: {
      name: '中文',
      subDomain: 'chinese',
    },
  };

  var currentLanguage;
  var matchMedia;
  var hostname;
  var $footer;
  var $footerPanel;
  var $footerAccordion;
  var $collapseIcon;
  var $expandIcon;
  var $availableLanguages;
  var $footerAccordionContainer;

  const footerPanel = '.js-footer-panel';
  const footerAccordion = '.js-footer-accordion';
  const collapseIcon = '.js-icon-collapse';
  const expandIcon = '.js-icon-expand';
  const availableLanguage = '.js-available-language';
  const footerAccordionContainer = '.js-footer-accordion-container';

  function initSelectors(element) {
    $footer = element;
    $footerPanel = $footer.querySelector(footerPanel);
    $footerAccordion = $footer.querySelector(footerAccordion);
    $collapseIcon = $footer.querySelector(collapseIcon);
    $expandIcon = $footer.querySelector(expandIcon);
    $availableLanguages = $footer.querySelectorAll(availableLanguage);
    $footerAccordionContainer = $footer.querySelector(footerAccordionContainer);
  }

  function initGlobalVariables() {
    matchMedia = window.matchMedia('(min-width: ' + (Constants.breakpoints.lg) + 'px)');
    hostname = window.location.hostname;
    currentLanguage = 'English';
  }

  function bindEvents() {
    matchMedia.addListener(enableAccordion);
    $footerAccordionContainer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        toggleAccordion();
      }
    });
  }

  function enableAccordion() {
    if (matchMedia.matches) {
      $footerAccordion.removeEventListener('click', toggleAccordion);
      $footerPanel.removeAttribute('style');
      $collapseIcon.removeAttribute('style');
      $expandIcon.removeAttribute('style');
    } else {
      $footerAccordion.addEventListener('click', toggleAccordion);
    }
  }

  function toggleAccordion() {
    Ut.slideToggle($footerPanel, 400);
    Ut.slideToggle($expandIcon);
    Ut.slideToggle($collapseIcon);
  }

  function updateLanguageLink() {

    Object.entries(languages).forEach(function (el) {
      if (hostname.indexOf(el[1].subDomain) !== -1) {
        currentLanguage = el[1].name;
      }
    });

    $availableLanguages.forEach(function (item) {
      var $item = item;
      if ($item.innerText === currentLanguage) {
        $item.style.textDecoration = 'underline';
      }
    });
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    bindEvents();
    enableAccordion();
    updateLanguageLink();
  }

  return {
    init: init,
  };
};
